<template>
<Dialog v-model="visible" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{$t('curtain.control')}}</span>
  </template>

  <template v-for="d in availableOpenDirections">
    <v-slider :value="getPercentByDirection(d)" @change="val=>changePercent(d,val)" :key="d" :prepend-icon="directionIcon(d)" min="0" max="100" thumb-label="always" track-color="grey" track-fill-color="primary" class="ma-5 pt-5" hide-details>
    </v-slider>
  </template>

  <template slot="actions">
    <v-btn outlined color="secondary" @click="open(false)">{{ $t('curtain.close') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn outlined color="primary" @click="open(true)">{{ $t('curtain.open') }}</v-btn>
  </template>

</Dialog>
</template>

<script>
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'

let delayHandler;

export default {
  name: 'CurtainControlDialog',
  mixins: [BaseDialog],
  components: {
    Dialog
  },
  props: {
    openState: {
      type: Array
    },
    availableOpenDirections: {
      type: Array
    }
  },
  computed: {
    stateInner: {
      get() {
        return this.openState;
      },
      set(val) {
        this.$emit('update:openState', val);
      }
    }
  },
  methods: {
    directionIcon(d) {
      switch (d) {
        case 'UP':
          return 'mdi-arrow-expand-up';
        case 'DOWN':
          return 'mdi-arrow-expand-down';
        case 'LEFT':
          return 'mdi-arrow-expand-left';
        case 'RIGHT':
          return 'mdi-arrow-expand-right';
        case 'IN':
          return 'mdi-arrow-collapse-horizontal';
        case 'OUT':
          return 'mdi-arrow-expand-horizontal';
      }
      return '';
    },
    getPercentByDirection(direction) {
      return (this.stateInner.find(s => s.openDirection == direction) || {}).openPercent;
    },
    changePercent(direction, val) {
      if (delayHandler) clearTimeout(delayHandler);
      delayHandler = setTimeout(() => {
        this.$emit('change', {
          openPercent: val,
          openDirection: direction
        });
      }, 500);
    },
    open(val) {
      this.$emit('change', {
        openPercent: val ? 100 : 0
      });
    }
  }
}
</script>

<style>
.v-slider__track-container {
  border-radius: 3px;
  height: 6px !important;
}

.v-slider__track-background {
  border-radius: 4px;
}

.v-slider__track-fill {
  border-radius: 4px;
}
</style>
